import { cmToIn, ftInToIn, inToCm, inToFtIn, kgToLb, lbToKg, roundToDecimal } from '@/utils/helpers';

export const calculateBmi = (weightKg?: string | null, heightCm?: string | null): string | null => {
  const w = parseFloat(weightKg ?? '');
  const h = parseFloat(heightCm ?? '');
  if (!w || !h || w < 0 || h < 0) return null;
  const heightM = h / 100;
  return String(Math.round((w / (heightM * heightM)) * 10) / 10);
};

export const getRoundedInputValue = (value?: string | null, precision = 3): string => {
  if (value === undefined || value === null) return '';
  const num = parseFloat(value as string);
  return Number.isFinite(num) ? roundToDecimal(num, precision).toString() : '';
};

/**
 * cm <-> ft/in and kg <-> lb string conversions, shared by every dual-unit height/weight
 * input (donor and recipient) so the rounding/parsing rules stay in one place.
 */
export const cmToFtInString = (cm: string): { ft: string; in: string } => {
  const value = parseFloat(cm);
  if (!Number.isFinite(value)) return { ft: '', in: '' };
  const ftIn = inToFtIn(cmToIn(value), 2);
  return { ft: String(ftIn.ft), in: String(ftIn.in) };
};

export const ftInToCmString = (ft: string, inches: string): string => {
  const ftNum = parseFloat(ft);
  const inNum = parseFloat(inches);
  if (!Number.isFinite(ftNum) && !Number.isFinite(inNum)) return '';
  const totalIn = ftInToIn(Number.isFinite(ftNum) ? ftNum : 0, Number.isFinite(inNum) ? inNum : 0);
  return String(inToCm(totalIn));
};

export const kgToLbString = (kg: string): string => {
  const value = parseFloat(kg);
  return Number.isFinite(value) ? String(kgToLb(value, 2)) : '';
};

export const lbToKgString = (lb: string): string => {
  const value = parseFloat(lb);
  return Number.isFinite(value) ? String(lbToKg(value)) : '';
};
